import { useTranslation } from 'react-i18next';
import KoobTitle from '../../../components/Koob/KoobTitle';
import KoobParagraph from '../../../components/Koob/KoobParagraph';
import { KoobButton } from '@koob/ui';
import { useExperienceField, useTripStore } from '@koob/trip-designer';

export default function ExperienceExtrasModalSkipTransitionExtra({
  dayIndex,
  onSkip,
}) {
  const { t } = useTranslation('tripDesigner');
  const [{ value: experience }] = useExperienceField(dayIndex);
  const updateDay = useTripStore(state => state.updateDay);

  const skipTransitionOption = () => {
    // Calculate the last day of the experience (where the transition happens)
    const experienceStartIndex = dayIndex - ((experience?.dayIndex ?? 1) - 1);
    const lastDayIndex =
      experienceStartIndex + (experience?.durationDays ?? 1) - 1;

    // Update the day's skipTransitionOption field (persisted to API)
    updateDay(lastDayIndex, { skipTransitionOption: true });

    // Defer onSkip to next tick to ensure Zustand state has propagated
    // before the modal-opening effect re-evaluates
    setTimeout(() => {
      onSkip();
    }, 0);
  };

  return (
    <div className="m-3 bg-gray-100 p-4 rounded-lg">
      <div className="flex justify-between items-center">
        <div>
          <KoobTitle size="lg">
            {t('extrasModal.recommendation.other.title')}
          </KoobTitle>
          <KoobParagraph size="md">
            {t('extrasModal.recommendation.other.description')}
            <br />
          </KoobParagraph>
        </div>

        <div>
          <KoobButton variant="primary" onClick={() => skipTransitionOption()}>
            {t('extrasModal.recommendation.other.button')} &rarr;
          </KoobButton>
        </div>
      </div>
    </div>
  );
}
